// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__fLlhD","icon":"SortAdornment_icon__3i2yF","up":"SortAdornment_up__1VqUh","down":"SortAdornment_down__1nlXn","active":"SortAdornment_active__Gc6Hv"};